var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerrestre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 261,
    viewBox: "0 0 265 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_79)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: -3,
    width: 184.555,
    height: 184.555,
    rx: 14,
    transform: "rotate(45 136 -3)",
    fill: "#008E81"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: -2.29289,
    width: 183.555,
    height: 183.555,
    rx: 13.5,
    transform: "rotate(45 136 -2.29289)",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.104 144.339C136.619 144.339 138.658 146.593 138.658 149.373V186.964C138.658 189.745 136.619 191.999 134.104 191.999C131.589 191.999 129.55 189.745 129.55 186.964V149.373C129.55 146.593 131.589 144.339 134.104 144.339Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.532 112.119C122.047 112.119 124.086 114.373 124.086 117.153V186.965C124.086 189.746 122.047 192 119.532 192C117.017 192 114.978 189.746 114.978 186.965V117.153C114.978 114.373 117.017 112.119 119.532 112.119Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.91 122.562C136.837 120.776 139.709 121.055 141.325 123.186L176.115 169.06C177.295 170.46 178.046 172.301 177.998 174.359C177.95 176.436 177.1 178.183 175.994 179.393C173.784 181.811 170.253 182.518 167.133 180.77C166.958 180.672 166.788 180.561 166.626 180.439L134.466 156.204C134.462 156.201 134.459 156.198 134.455 156.196C130.805 153.467 128.964 148.566 128.989 143.445C128.989 143.278 128.998 143.11 129.014 142.944L130.492 127.429C130.721 125.024 132.446 123.193 134.537 122.949C134.653 122.814 134.778 122.685 134.91 122.562ZM138.869 135.619L138.097 143.723C138.137 146.209 139.033 147.465 139.558 147.855L139.576 147.87L159.607 162.964L138.869 135.619Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0574 99.5007C97.6514 96.9945 102.884 98.3456 105.99 100.662C106.06 100.714 106.129 100.768 106.196 100.824L117.32 110.15C119.013 111.57 119.556 114.045 118.766 116.115C118.885 116.437 118.975 116.778 119.033 117.134C119.475 119.871 117.827 122.487 115.351 122.976L62.3646 133.449C58.1631 134.479 55.1669 131.263 54.3087 128.121C53.4248 124.884 54.3678 120.607 58.066 118.59L93.0574 99.5007ZM107.254 114.348L100.819 108.953C100.396 108.662 99.7299 108.37 98.9699 108.267C98.1751 108.159 97.5323 108.288 97.0873 108.53L74.5899 120.804L107.254 114.348Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.139 43.2074C155.038 43.9648 157.832 46.9264 157.812 51.1366C157.812 51.2264 157.809 51.3162 157.805 51.4058L155.511 94.4931C155.42 99.9155 151.911 104.41 148.051 106.516C147.989 106.55 147.927 106.582 147.864 106.613L135.27 112.713C133.177 113.727 130.769 112.862 129.589 110.785C129.19 110.748 128.789 110.653 128.395 110.493C126.034 109.534 124.823 106.642 125.689 104.032L144.007 48.8617C144.433 47.0171 145.382 45.2663 146.997 44.1286C148.699 42.9298 150.591 42.803 152.139 43.2074ZM136.328 101.207L144.1 97.4429C145.744 96.509 146.402 94.9583 146.405 94.2864C146.406 94.1965 146.408 94.1068 146.413 94.0171L147.883 66.4065L136.328 101.207Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.247 112.119C126.396 112.119 124.086 114.674 124.086 117.825C124.086 120.976 126.396 123.531 129.247 123.531C132.097 123.531 134.407 120.976 134.407 117.825C134.407 114.674 132.097 112.119 129.247 112.119ZM114.978 117.825C114.978 109.113 121.366 102.05 129.247 102.05C137.127 102.05 143.515 109.113 143.515 117.825C143.515 126.537 137.127 133.6 129.247 133.6C121.366 133.6 114.978 126.537 114.978 117.825Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_79",
    x: 7.299,
    y: 2.799,
    width: 257.402,
    height: 257.402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_79",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrestre);
export default __webpack_public_path__ + "static/media/terrestre.5f2052bac662410035504c0d1a34214b.svg";
export { ForwardRef as ReactComponent };